<template>
  <div class="landing-page">
    <!-- Header -->
    <header class="header">
      <div class="header-container">
        <nav class="nav">
          <!-- Logo -->
          <div class="logo">
            <a href="https://intelite.com.br/" target="_blank" rel="noopener noreferrer">
              <img 
                src="@/assets/logoInteliteAzul.png" 
                alt="Intelite Tecnologia" 
                class="logo-image"
              />
            </a>
          </div>

          <!-- Menu Desktop -->
          <div class="nav-desktop">
            <button
              v-for="item in menuItems"
              :key="item.id"
              @click="scrollToSection(item.id)"
              class="nav-button"
              :class="{ 'active': activeSection === item.id }"
            >
              <span 
                class="nav-underline"
                :class="{ 'active': activeSection === item.id }"
              ></span>
              {{ item.label }}
            </button>
          </div>

          <!-- Botão Login Desktop -->
          <div class="login-desktop">
            <button
              @click="goToLogin"
              class="login-button"
            >
              <svg class="login-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
              </svg>
              LOGIN
            </button>
          </div>

          <!-- Menu Mobile Button -->
          <button
            @click="toggleMenu"
            class="menu-toggle"
          >
            <svg
              class="menu-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                v-if="!isMenuOpen"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
              <path
                v-else
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </nav>
      </div>

      <!-- Overlay escuro -->
      <div v-if="isMenuOpen" class="overlay" @click="toggleMenu"></div>

      <!-- Menu Mobile -->
      <div
        class="nav-mobile"
        :class="{ 'open': isMenuOpen }"
      >
        <div class="nav-mobile-content">
          <button
            v-for="item in menuItems"
            :key="item.id"
            @click="scrollToSection(item.id)"
            class="nav-button-mobile"
            :class="{ 'active': activeSection === item.id }"
          >
            {{ item.label }}
          </button>
          
          <!-- Botão Login Mobile -->
          <button
            @click="goToLogin"
            class="login-button"
          >
            <svg class="login-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
            </svg>
            LOGIN
          </button>
        </div>
      </div>
    </header>

    <!-- Hero Section -->
    <section id="home" class="hero-section">
      <div class="hero-banner-container">
        <img src="@/assets/banner01LandPage.png" alt="Hero Background" class="hero-background">
      
      <div class="hero-content">
        <div class="hero-left">
          <img src="@/assets/aifitLogo.png" alt="Intelite Tecnologia" class="hero-logo">
        </div>
      </div>
      </div>
    </section>

    <!-- About Section -->
    <section id="sobre" class="about-section">
      <div class="container">
        <div class="about-content">
          <div class="about-image mt-10">
            <img src="@/assets/banner02LandPage.png" alt="About AiFit" class="about-img">
          </div>
          <div class="about-text">
            <h2 class="section-title">Sobre o AiFit</h2>
            <div class="about-text-content">
              <p class="section-description">
                O AiFit é uma solução desenvolvida especialmente para academias que transforma a forma de gerenciar check-ins e atendimentos. De maneira simples e automatizada, o sistema conecta alunos a professores disponíveis, garantindo organização e eficiência no dia a dia.
                Além de facilitar o controle de presença, o AiFit também coleta a percepção dos alunos por meio de pesquisas rápidas no checkout, permitindo que as academias acompanhem a qualidade das aulas e aprimorem continuamente seus serviços.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Advantages Section -->
    <section id="vantagens" class="advantages-section">
      <div class="container">
        <div class="advantages-content">
          <div class="advantages-image">
            <img src="@/assets/vantagensLandPage.png" alt="Vantagens" class="advantages-img">
          </div>
          <div class="advantages-text">
            <div class="advantages-text-content">
              <div class="advantages-list">
                <div class="advantage-item">
                  <img src="@/assets/checkIcon.png" alt="Venda Assistida" class="check-icon">
                  <span class="advantage-text">Venda Assistida</span>
                </div>
                <div class="advantage-item">
                  <img src="@/assets/checkIcon.png" alt="Venda Assistida" class="check-icon">
                  <span class="advantage-text">Controle de vendas online;</span>
                </div>
                <div class="advantage-item">
                  <img src="@/assets/checkIcon.png" alt="Venda Assistida" class="check-icon">
                  <span class="advantage-text">Comunicação com o publico através de Whatsapp;</span>
                </div>
                <div class="advantage-item">
                  <img src="@/assets/checkIcon.png" alt="Venda Assistida" class="check-icon">
                  <span class="advantage-text">Histórico de consumo via whatsapp;</span>
                </div>
                <div class="advantage-item">
                  <img src="@/assets/checkIcon.png" alt="Venda Assistida" class="check-icon">
                  <span class="advantage-text">Relatório de gerenciamento em tempo real;</span>
                </div>
                <div class="advantage-item">
                  <img src="@/assets/checkIcon.png" alt="Venda Assistida" class="check-icon">
                  <span class="advantage-text">Recarga simplificada;</span>
                </div>
                <div class="advantage-item">
                  <img src="@/assets/checkIcon.png" alt="Venda Assistida" class="check-icon">
                  <span class="advantage-text">Controle de estoque.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Clients Section -->
    <section id="clientes" class="clients-section">
      <div class="container">
        <div class="clients-content">
          <div class="clients-image">
            <img src="@/assets/clientesLandPage.png" alt="Clientes" class="clients-img">
          </div>
          <div class="clients-text">
            <div class="clients-logos">
              <img src="@/assets/pcStudio.jpg" alt="Vista Alegre" class="client-logo">
              <img src="@/assets/studioF.jpg" alt="Peça e Retire" class="client-logo">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- WhatsApp Button Section -->
    <section id="contato" class="whatsapp-section">
      <div class="container">
        <div class="whatsapp-content">
          <a href="https://wa.link/amh3qf" target="_blank" class="whatsapp-button">
            <v-icon color="white" class="whatsapp-icon">mdi-whatsapp</v-icon>
            <span class="whatsapp-text">FALE CONOSCO</span>
          </a>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer">
      <div class="container">
        <!-- Logo Section -->
        <div class="footer-logo-section">
          <img src="@/assets/logoInteliteAzul.png" alt="Intelite Tecnologia" class="footer-logo-img">
        </div>
        
        <!-- Information Section -->
        <div class="footer-info-section">
          <div class="footer-column">
            <h3 class="footer-column-title">Endereço</h3>
            <div class="footer-info-item">
              <v-icon color="white" class="footer-icon">location_on</v-icon>
              <div class="footer-info-text">
                <div>R. Carteiro Olivio Pontes, 575 - Água Fria</div>
                <div>João Pessoa - PB, 58053-020</div>
              </div>
            </div>
          </div>
          
          <div class="footer-column">
            <h3 class="footer-column-title">Contato</h3>
            <div class="footer-info-item">
              <v-icon color="white" class="footer-icon">phone</v-icon>
              <div class="footer-info-text">(83) 3512-5222</div>
            </div>
            <div class="footer-info-item">
              <v-icon color="white" class="footer-icon">email</v-icon>
              <div class="footer-info-text">comercial@intelite.com.br</div>
            </div>
          </div>
          
          <div class="footer-column">
            <h3 class="footer-column-title">Redes Sociais</h3>
            <div class="footer-social-icons">
              <a href="https://www.instagram.com/intelite_tecnologia/" target="_blank" class="social-icon">
                <v-icon color="white" class="footer-icon">mdi-instagram</v-icon>
              </a>
              <a href="https://www.linkedin.com/company/intelite-tecnologia/" target="_blank" class="social-icon">
                <v-icon color="white" class="footer-icon">mdi-linkedin</v-icon>
              </a>
            </div>
          </div>
        </div>
        
        <!-- Separator Line -->
        <div class="footer-separator"></div>
        
        <!-- Copyright Section -->
        <div class="footer-copyright">
          <p>© 2025 Intelite Tecnologia. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>

    <!-- WhatsApp Floating Button -->
    <a href="https://wa.link/amh3qf" target="_blank" class="whatsapp-floating-button">
      <v-icon color="white" class="whatsapp-floating-icon">mdi-whatsapp</v-icon>
    </a>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data() {
    return {
      isMenuOpen: false,
      activeSection: 'home',
      isScrolling: false,
      menuItems: [
        { id: 'home', label: 'HOME' },
        { id: 'sobre', label: 'SOBRE' },
        { id: 'vantagens', label: 'VANTAGENS' },
        { id: 'clientes', label: 'CLIENTES' },
        { id: 'contato', label: 'CONTATO' }
      ]
    }
  },
  mounted() {
    // Smooth scroll para navegação
    this.setupSmoothScroll()
    // Observar seções para atualizar navegação ativa
    this.setupIntersectionObserver()
    // Observar elementos para animações de entrada
    this.setupScrollAnimations()
    // Adicionar listener de scroll
    window.addEventListener('scroll', this.updateActiveSection)
    this.updateActiveSection()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateActiveSection)
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },

    goToLogin() {
      this.$router.push('/login')
    },
    
    scrollToSection(sectionId) {
      // Define imediatamente a seção ativa para evitar piscadas
      this.activeSection = sectionId
      this.isMenuOpen = false
      this.isScrolling = true // Desabilita updateActiveSection durante o scroll
      
      if (sectionId === 'contato') {
        // Para contato, vai para o footer
        const footer = document.querySelector('.footer')
        if (footer) {
          const headerHeight = 80
          const targetPosition = footer.offsetTop - headerHeight
          
          // Scroll suave com animação personalizada
          this.smoothScrollTo(targetPosition)
        }
      } else {
        // Para outras seções, comportamento normal
        const element = document.getElementById(sectionId)
        if (element) {
          const headerHeight = 80
          const targetPosition = element.offsetTop - headerHeight
          
          // Scroll suave com animação personalizada
          this.smoothScrollTo(targetPosition)
        }
      }
    },

    smoothScrollTo(targetPosition) {
      const startPosition = window.pageYOffset
      const distance = targetPosition - startPosition
      const duration = 800 // 800ms
      let start = null

      const animation = (currentTime) => {
        if (start === null) start = currentTime
        const timeElapsed = currentTime - start
        const run = this.easeInOutQuad(timeElapsed, startPosition, distance, duration)
        window.scrollTo(0, run)
        if (timeElapsed < duration) {
          requestAnimationFrame(animation)
        } else {
          // Reabilita updateActiveSection quando terminar o scroll
          this.isScrolling = false
        }
      }

      requestAnimationFrame(animation)
    },

    easeInOutQuad(t, b, c, d) {
      t /= d / 2
      if (t < 1) return c / 2 * t * t + b
      t--
      return -c / 2 * (t * (t - 2) - 1) + b
    },

    setupSmoothScroll() {
      // Método mantido para compatibilidade, mas agora usa scrollToSection
      const links = document.querySelectorAll('.nav-link')
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          const targetId = link.getAttribute('href')
          if (targetId) {
            this.scrollToSection(targetId.substring(1))
          }
        })
      })
    },
    setupIntersectionObserver() {
      const sections = document.querySelectorAll('section[id]')
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isScrolling) {
            this.activeSection = entry.target.id
          }
        })
      }, {
        threshold: 0.3,
        rootMargin: '-100px 0px -100px 0px'
      })

      sections.forEach(section => {
        observer.observe(section)
      })
    },

    updateActiveSection() {
      // Não atualiza durante o scroll programático
      if (this.isScrolling) return
      
      const sections = ['home', 'sobre', 'vantagens', 'clientes']
      const headerHeight = 100

      for (const sectionId of sections) {
        const element = document.getElementById(sectionId)
        if (element) {
          const rect = element.getBoundingClientRect()
          
          if (rect.top <= headerHeight && rect.bottom > headerHeight) {
            // Só atualiza se for diferente da seção atual
            if (this.activeSection !== sectionId) {
              this.activeSection = sectionId
            }
            return
          }
        }
      }
      
      // Se chegou até aqui, verifica se está no footer
      const footer = document.querySelector('.footer')
      if (footer) {
        const rect = footer.getBoundingClientRect()
        // Só marca como contato se estiver realmente no footer
        if (rect.top <= headerHeight && rect.bottom > headerHeight) {
          if (this.activeSection !== 'contato') {
            this.activeSection = 'contato'
          }
        }
      }
    },
    setupScrollAnimations() {
      // Elementos que devem ser animados
      const animatedElements = [
        { selector: '.hero-logo', animation: 'fadeInUp' },
        { selector: '.about-img', animation: 'fadeInLeft' },
        { selector: '.section-title', animation: 'fadeInRight' },
        { selector: '.section-description', animation: 'fadeInRight' },
        { selector: '.advantages-img', animation: 'fadeInLeft' },
        { selector: '.advantage-item', animation: 'fadeInUp' },
        { selector: '.clients-img', animation: 'fadeInLeft' },
        { selector: '.client-logo', animation: 'fadeInUp' },
        { selector: '.whatsapp-button', animation: 'bounceInUp' }
      ]

      // Configuração do Intersection Observer
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target
            
            // Aplicar animação baseada no tipo de elemento
            if (element.classList.contains('advantage-item')) {
              // Para itens de vantagem, aplicar delay baseado na posição
              const items = document.querySelectorAll('.advantage-item')
              const index = Array.from(items).indexOf(element)
              element.style.animationDelay = `${index * 0.2}s`
              element.classList.add('animate-fadeInUp')
            } else if (element.classList.contains('client-logo')) {
              // Para logos de clientes, aplicar delay baseado na posição
              const logos = document.querySelectorAll('.client-logo')
              const index = Array.from(logos).indexOf(element)
              element.style.animationDelay = `${index * 0.2}s`
              element.classList.add('animate-fadeInUp')
            } else {
              // Para outros elementos, aplicar animação diretamente
              const animationClass = element.dataset.animation || 'fadeInUp'
              element.classList.add(`animate-${animationClass}`)
            }
            
            // Parar de observar o elemento após animação
            observer.unobserve(element)
          }
        })
      }, observerOptions)

      // Observar todos os elementos
      animatedElements.forEach(({ selector, animation }) => {
        const elements = document.querySelectorAll(selector)
        elements.forEach(element => {
          element.dataset.animation = animation
          element.classList.add('animate-ready')
          observer.observe(element)
        })
      })
    }
  }
}
</script>

<style scoped>
.landing-page {
  font-family: 'Roboto', sans-serif;
  line-height: 1.6;
}

/* Header */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 50;
  height: 86px; 
  border-top: 3px solid #0f0f41;
  transition: all 0.3s ease;
}

@media (max-width: 768px) {
  .header {
    height: 66px;
  }
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .header-container {
    padding: 8px 16px;
    min-height: 70px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;
    padding-top: 6px;
  }
  
  .nav {
    justify-content: center;
  }
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.logo {
  width: 160px;
  overflow: visible;
}

.logo a {
  text-decoration: none;
  display: block;
}

.logo-image {
  height: auto;
  width: 100%;
  margin-left: 0;
  transition: opacity 0.3s ease;
}

/* Aproxima somente a imagem no desktop, mantendo layout intacto */
@media (min-width: 960px) {
  .logo-image {
    margin-left: 0;
    transform: translateX(-30px);
  }
}

@media (min-width: 1440px) {
  .logo-image {
    transform: translateX(-60px);
  }
}

@media (min-width: 1920px) {
  .logo-image {
    transform: translateX(-90px);
  }
}

@media (max-width: 768px) {
  .logo-image {
    margin-left: 0px;
    transform: none;
  }
  
  .logo {
    width: 140px;
    display: flex;
    justify-content: center;
  }
}

.logo a:hover .logo-image {
  opacity: 0.8;
}

.nav-desktop {
  display: flex;
  flex: 1;
  justify-content: center;
  gap: 48px;
}

.login-desktop {
  display: flex;
  align-items: center;
  margin-left: auto;
  height: 100%;
}

.nav-button {
  color: #374151;
  background: none;
  border: none;
  font-weight: 700;
  position: relative;
  padding: 8px 0;
  cursor: pointer;
  transition: color 0.3s ease;
  text-transform: uppercase;
  font-size: 16px;
}

.nav-button:hover {
  color: #111827;
}

.nav-button.active {
  color: #2B3674;
  font-weight: 700;
}

.nav-underline {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #2B3674;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.nav-underline.active {
  transform: scaleX(1);
}

.login-button {
  background: #7bb100;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  min-width: 120px;
}

.login-button:hover {
  background: #6a9e00;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(123, 177, 0, 0.3);
}

.login-icon {
  width: 16px;
  height: 16px;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: #374151;
  cursor: pointer;
  margin-left: auto;
  order: 2;
}

.menu-toggle:hover {
  color: #111827;
}

.menu-icon {
  width: 24px;
  height: 24px;
}

@media (max-width: 768px) {
  .menu-icon {
    width: 32px;
    height: 32px;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 30;
}

.nav-mobile {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 40;
  transform: translateY(-100%);
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.nav-mobile.open {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.nav-mobile-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 40px 0;
}

.nav-button-mobile {
  color: #374151;
  background: none;
  border: none;
  font-weight: 700;
  font-size: 20px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.nav-button-mobile:hover {
  color: #111827;
}

.nav-button-mobile.active {
  color: #2B3674;
  font-weight: 700;
}

/* Estilo para o botão de login no mobile (usando a mesma classe) */
.nav-mobile .login-button {
  margin-top: 16px;
}


/* Hero Section */
.hero-section {
  width: 100%;
  margin-top: 86px;
}

@media (max-width: 768px) {
  .hero-section {
    margin-top: 66px;
  }
  
  .hero-banner-container {
    height: 450px;
  }
  
  .hero-content {
    flex-direction: column;
    padding: 20px 3%;
    gap: 20px;
    align-items: center;
    justify-content: center;
    transform: translateX(-15px);
  }
  
  .hero-left {
    max-width: 100%;
    align-items: center;
    text-align: center;
    order: 2;
    display: flex;
    justify-content: center;
  }
  
  .hero-logo {
    max-width: 250px;
    width: 75%;
    margin: 0 auto;
  }
}

.hero-banner-container {
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  z-index: 1;
}

@media (max-width: 768px) {
  .hero-background {
    object-position: 50% center;
  }
}

@media (max-width: 480px) {
  .hero-background {
    object-position: 65% center;
  }
}

.hero-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 5%;
  max-width: 1200px;
  margin: 0 auto;
}

.hero-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex: 1;
  max-width: 50%;
}

.hero-text {
  color: white;
  font-family: 'Poppins Bold', sans-serif;
  font-weight: 900;
  font-size: 3.5rem;
  line-height: 1.1;
  text-align: left;
  animation: slideInLeft 1s ease-out;
}

.text-line {
  display: block;
  opacity: 0;
  animation: fadeInUp 0.8s ease-out forwards;
}

.text-line:nth-child(1) { animation-delay: 0.2s; }
.text-line:nth-child(2) { animation-delay: 0.4s; }
.text-line:nth-child(3) { animation-delay: 0.6s; }
.text-line:nth-child(4) { animation-delay: 0.8s; }
.text-line:nth-child(5) { animation-delay: 1s; }

.hero-check-icon {
  width: 40px;
  height: 40px;
  filter: brightness(0) invert(1);
}

.hero-right {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 50%;
}

.hero-logo {
  width: 100%;
  max-width: 400px;
  height: auto;
  object-fit: contain;
  animation: fadeInUp 0.8s ease-out;
}

.hero-cards {
  width: 350px;
  max-width: none;
  height: auto;
  object-fit: contain;
  animation: slideInRight 1.2s ease-out;
}

/* About Section */
.about-section {
  padding: 40px 0;
  background: white;
}

.about-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.about-image {
  width: 100%;
  display: flex;
  justify-content: center;
}

.about-img {
  width: 80%;
  height: auto;
}

.about-text {
  text-align: justify;
  max-width: 1400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0 20px;
}

.about-text-content {
  text-align: justify;
  width: 100%;
}

.section-title {
  font-family: 'AlibabaSans', sans-serif;
  font-size: 24px;
  color: #7bb100;
  margin-bottom: 32px;
  font-weight: 700;
  text-align: left;
  width: 100%;
}

@media (min-width: 768px) {
  .section-title {
    font-size: 30px;
  }
}

@media (min-width: 1024px) {
  .section-title {
    font-size: 36px;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 20px;
    line-height: 1.35;
    margin-bottom: 16px;
    letter-spacing: 0;
    word-break: keep-all;
  }
}

.section-description {
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  color: #070b11;
  line-height: 1.75;
  text-indent: 2em;
  font-weight: 400;
}

@media (min-width: 768px) {
  .section-description {
    font-size: 20px;
  }
}

@media (min-width: 1024px) {
  .section-description {
    font-size: 20px;
  }
}

/* Advantages Section */
.advantages-section {
  padding: 40px 0;
  background: white;
}

.advantages-content {
  text-align: justify;
  width: 100%;
}

.advantages-image {
  width: 100%;
  display: flex;
  justify-content: center;
}

.advantages-img {
  width: 50%;
  height: auto;
}

.advantages-text {
  text-align: justify;
  max-width: 1400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 auto;
  margin-top: 20px;
  padding: 0 20px;
}

.advantages-text-content {
  text-align: justify;
  width: 100%;
}

.advantages-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
}

.advantage-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
}

.check-icon {
  font-size: 24px !important;
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 768px) {
  .check-icon {
    width: 28px;
    height: 28px;
    font-size: 28px !important;
    min-width: 28px;
  }
}

.advantage-text {
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  line-height: 29px;
  color: #090913;
  font-weight: 700;
}

@media (min-width: 768px) {
  .advantage-text {
    font-size: 20px;
    line-height: 32.5px;
  }
}

/* Clients Section */
.clients-section {
  padding: 40px 0;
  background: white;
}

.clients-content {
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.clients-image {
  width: 100%;
  display: flex;
  justify-content: center;
}

.clients-img {
  width: 50%;
  height: auto;
  margin-bottom: 20px;
}

.clients-text {
  text-align: center;
  max-width: 1400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
}

.clients-text-content {
  text-align: center;
  width: 100%;
}

.clients-logos {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  align-items: center;
  justify-items: center;
  margin-top: 30px;
  width: 100%;
}

.client-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 120px;
}

.client-logo img {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
  object-fit: contain;
  transition: transform 1s ease;
  cursor: pointer;
}

.client-logo:hover {
  transform: scale(1.05);
}

/* WhatsApp Button Section */
.whatsapp-section {
  padding: 40px 0 80px;
  background: white;
  overflow: visible;
}

.whatsapp-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 30px 0;
}

.whatsapp-button {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #7bb100;
  color: white;
  text-decoration: none;
  padding: 25px 60px;
  border-radius: 50px;
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: transform 1s ease, background 1s ease, box-shadow 1s ease;
  box-shadow: 0 4px 15px rgba(37, 211, 46, 0.3);
  min-width: 300px;
  position: relative;
  z-index: 1;
  cursor: pointer;
}

.whatsapp-button:hover {
  background: #227a1a;
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(37, 211, 46, 0.4);
  text-decoration: none;
  color: white;
}

.whatsapp-icon {
  font-size: 24px !important;
}

.whatsapp-text {
  font-weight: bold;
  font-size: 18px;
}

/* Footer */
.footer {
  background: #7bb100;
  padding: 60px 0 30px 0;
  color: white;
  text-align: center;
}

.footer .container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-logo-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  width: 100%;
  order: 1;
}

.footer-logo-img {
  height: 80px;
  width: auto;
  filter: brightness(0) invert(1);
}

.footer-info-section {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 80px;
  margin-bottom: 40px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  order: 2;
}

.footer-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  max-width: 300px;
}

.footer-column-title {
  font-size: 18px;
  font-weight: bold;
  color: white;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-info-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 15px;
  text-align: center;
}

.footer-icon {
  font-size: 20px !important;
  flex-shrink: 0;
}

.footer-info-text {
  font-size: 14px;
  line-height: 1.5;
  color: white;
  text-align: center;
}

.footer-social-icons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-icon:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
  text-decoration: none;
}

.footer-separator {
  width: 100%;
  max-width: 1200px;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 30px auto;
  display: block;
  order: 3;
}

.footer-copyright {
  text-align: center;
  padding-top: 20px;
  order: 4;
}

.footer-copyright p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

/* Large Desktop (1200px and above) */
@media (min-width: 1200px) {
  .container {
    max-width: 1400px;
  }

  .clients-logos {
    gap: 60px;
  }

  .client-logo {
    width: 220px;
    height: 130px;
  }

  .section-title {
    font-size: 2rem;
  }

  .section-description {
    font-size: 1.2rem;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .nav-desktop {
    display: none;
  }
  
  .login-desktop {
    display: none;
  }
  
  .menu-toggle {
    display: block;
    position: absolute;
    right: 20px;
    top: 12px;
  }
  
  
  .logo {
    width: 140px;
  }

  .hero-banner-container {
    height: 480px;
  }

  .hero-content {
    flex-direction: column;
    padding: 15px 4%;
    gap: 25px;
    align-items: center;
    justify-content: center;
    transform: translateX(-10px);
  }

  .hero-left {
    max-width: 100%;
    align-items: center;
    text-align: center;
    order: 2;
    display: flex;
    justify-content: center;
  }

  .hero-text {
    font-size: 2.5rem;
    text-align: center;
  }

  .hero-check-icon {
    width: 30px;
    height: 30px;
  }

  .hero-right {
    max-width: 100%;
    order: 1;
  }

  .hero-logo {
    max-width: 280px;
    width: 80%;
    margin: 0 auto;
  }

  .hero-cards {
    max-width: 350px;
    width: 85%;
  }

  /* About Section Mobile */
  .about-section {
    padding: 40px 0 60px 0;
  }

  .about-content {
    gap: 30px;
  }

  .about-img {
    width: 95%;
  }

  .about-text {
    max-width: 95%;
    width: 95%;
    padding: 0 10px;
  }

  .section-title {
    font-size: 2rem;
    margin-bottom: 20px;
  }

  .section-description {
    font-size: 1rem;
    margin-bottom: 15px;
    line-height: 1.6;
  }

  /* Advantages Section Mobile */
  .advantages-section {
    padding: 40px 0 60px 0;
  }

  .advantages-content {
    gap: 30px;
  }

  .advantages-img {
    width: 95%;
  }

  .advantages-text {
    max-width: 95%;
    width: 95%;
    padding: 0 10px;
  }

  

  .advantage-item {
    gap: 12px;
    padding: 3px 0;
  }

  .check-icon {
    font-size: 20px !important;
    min-width: 20px;
    height: 20px;
    }

  .advantage-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
    color: #090913;
    font-weight: 500;
  }

  /* Clients Section Mobile */
  .clients-section {
    padding: 40px 0 0 0;
  }

  .clients-content {
    gap: 30px;
  }

  .clients-img {
    width: 95%;
    margin-bottom: 15px;
  }

  .clients-text {
    max-width: 95%;
    width: 95%;
    padding: 0 10px;
  }

  .clients-logos {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 20px;
    justify-items: center;
    align-items: center;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }

  .client-logo {
    width: 160px;
    height: 100px;
  }

  /* WhatsApp Button Mobile */
  .whatsapp-section {
    padding: 60px 0 30px 0;
    overflow: visible;
  }

  .whatsapp-content {
    padding: 25px 0;
  }

  .whatsapp-button {
    padding: 18px 35px;
    font-size: 16px;
    min-width: 280px;
    width: 90%;
    max-width: 350px;
    justify-content: center;
  }

  .whatsapp-icon {
    font-size: 20px !important;
  }

  .whatsapp-text {
    font-size: 16px;
  }

  /* Footer Mobile */
  .footer {
    padding: 40px 0 20px 0;
  }

  .footer-logo-section {
    margin-bottom: 25px;
  }

  .footer-logo-img {
    height: 60px;
  }

  .footer-info-section {
    flex-direction: column;
    gap: 25px;
    margin-bottom: 25px;
    padding: 0 15px;
    width: 100%;
  }

  .footer-column {
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: none;
  }

  .footer-column-title {
    font-size: 16px;
    margin-bottom: 15px;
    font-weight: bold;
  }

  .footer-info-item {
    justify-content: center;
    text-align: center;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
  }

  .footer-info-text {
    font-size: 14px;
    line-height: 1.4;
  }

  .footer-social-icons {
    justify-content: center;
    gap: 15px;
  }

  .social-icon {
    width: 40px;
    height: 40px;
  }

  .footer-separator {
    margin: 25px auto;
    max-width: 90%;
  }

  .footer-copyright {
    padding: 15px 20px 0 20px;
  }

  .footer-copyright p {
    font-size: 13px;
    line-height: 1.4;
  }

  /* WhatsApp Floating Button Mobile */
  .whatsapp-floating-button {
    bottom: 20px;
    right: 20px;
    width: 55px;
    height: 55px;
  }

  .whatsapp-floating-icon {
    font-size: 26px !important;
  }
}

/* Tablet Styles (768px to 1024px) */
@media (max-width: 1024px) and (min-width: 769px) {
  .nav-content {
    gap: 80px;
  }
  
  .nav-menu {
    gap: 20px;
  }

  .logo {
    height: 60px;
  }

  .nav-link {
    font-size: 13px;
    padding: 8px 12px;
  }

  .about-img,
  .advantages-img,
  .clients-img {
    width: 85%;
  }

  .about-text,
  .advantages-text,
  .clients-text {
    max-width: 85%;
    width: 85%;
  }

  .section-title {
    font-size: 2rem;
  }

  .clients-logos {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    justify-items: center;
    align-items: center;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }

  .client-logo {
    width: 180px;
    height: 110px;
  }

  .whatsapp-button {
    min-width: 280px;
  }

  /* Footer Tablet */
  .footer-info-section {
    gap: 50px;
    padding: 0 30px;
  }

  .footer-column {
    max-width: 250px;
  }

  .footer-info-item {
    flex-direction: row;
    gap: 10px;
  }

  .footer-info-text {
    font-size: 14px;
  }

  .social-icon {
    width: 38px;
    height: 38px;
  }
}


/* Medium Mobile (481px to 768px) */
@media (max-width: 768px) and (min-width: 481px) {
  .header {
    height: 75px;
  }

  .logo {
    height: 50px;
  }

  .logo-section {
    height: 50px;
  }

  .hero-section {
    margin-top: 75px;
  }

  .mobile-nav {
    top: 75px;
  }

  .clients-logos {
    flex-direction: row;
    gap: 25px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .client-logo {
    width: 140px;
    height: 90px;
  }
}

/* Mobile Menu Adjustments */
@media (max-width: 768px) {
  .mobile-nav {
    top: 70px;
  }
}

/* Extra Small Mobile (480px and below) */
@media (max-width: 480px) {

  /* Header Extra Small */
  .header {
    height: 60px;
  }

  .logo {
    height: 40px;
  }

  .logo-section {
    height: 40px;
  }

  .mobile-menu {
    right: 15px;
  }

  .nav-content {
    padding: 0 15px;
  }

  /* Hero Section Extra Small */
  .hero-section {
    margin-top: 60px;
  }

  .hero-banner-container {
    height: 400px;
  }

  .hero-content {
    padding: 10px 3%;
    gap: 15px;
    align-items: center;
    justify-content: center;
    transform: translateX(-20px);
  }

  .hero-text {
    font-size: 1.9rem;
  }

  .hero-check-icon {
    width: 22px;
    height: 22px;
  }

  .hero-logo {
    max-width: 220px;
    width: 70%;
    margin: 0 auto;
  }

  .hero-cards {
    max-width: 280px;
    width: 80%;
  }

  /* Sections Extra Small */
  .clients-section {
    padding: 30px 0 0 0;
  }

  .about-section {
    padding: 30px 0 50px 0;
  }

  .advantages-section {
    padding: 30px 0 50px 0;
  }

  .about-content,
  .advantages-content,
  .clients-content {
    gap: 25px;
  }

  .about-img,
  .advantages-img,
  .clients-img {
    width: 98%;
  }

  .about-text,
  .advantages-text,
  .clients-text {
    max-width: 98%;
    width: 98%;
    padding: 0 5px;
  }

  .section-title {
    font-size: 1.8rem;
    margin-bottom: 15px;
  }

  .section-description {
    font-size: 0.95rem;
    margin-bottom: 12px;
    line-height: 1.5;
  }

  /* Advantages Extra Small */
  

  .advantage-item {
    gap: 10px;
    padding: 2px 0;
  }

  .check-icon {
    font-size: 18px !important;
    min-width: 18px;
    height: 18px;
    }

  .advantage-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
    color: #090913;
    font-weight: 500;
  }

  /* Clients Extra Small */
  .clients-logos {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-top: 15px;
    justify-items: center;
    align-items: center;
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
  }

  .client-logo {
    width: 140px;
    height: 90px;
    padding: 10px;
  }

  /* WhatsApp Button Extra Small */
  .whatsapp-section {
    padding: 50px 0 25px 0;
    overflow: visible;
  }

  .whatsapp-content {
    padding: 20px 0;
  }

  .whatsapp-button {
    padding: 15px 30px;
    font-size: 14px;
    min-width: 260px;
    width: 95%;
    max-width: 320px;
    justify-content: center;
  }

  .whatsapp-icon {
    font-size: 18px !important;
  }

  .whatsapp-text {
    font-size: 14px;
  }

  /* Footer Extra Small */
  .footer {
    padding: 30px 0 15px 0;
  }

  .footer-logo-section {
    margin-bottom: 20px;
  }

  .footer-logo-img {
    height: 50px;
  }

  .footer-info-section {
    gap: 20px;
    margin-bottom: 20px;
    padding: 0 10px;
  }

  .footer-column {
    width: 100%;
  }

  .footer-column-title {
    font-size: 15px;
    margin-bottom: 12px;
    font-weight: bold;
  }

  .footer-info-item {
    flex-direction: column;
    gap: 6px;
    margin-bottom: 10px;
  }

  .footer-info-text {
    font-size: 13px;
    line-height: 1.3;
  }

  .footer-social-icons {
    gap: 12px;
  }

  .social-icon {
    width: 35px;
    height: 35px;
  }

  .footer-separator {
    margin: 20px auto;
    max-width: 95%;
  }

  .footer-copyright {
    padding: 10px 15px 0 15px;
  }

  .footer-copyright p {
    font-size: 12px;
    line-height: 1.3;
  }

  /* WhatsApp Floating Button Extra Small */
  .whatsapp-floating-button {
    bottom: 15px;
    right: 15px;
    width: 50px;
    height: 50px;
  }

  .whatsapp-floating-icon {
    font-size: 24px !important;
  }
}

/* Mobile Menu Position Fix */
@media (max-width: 480px) {
  .mobile-nav {
    top: 60px;
  }
}

/* Animations */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bounceInUp {
  0% {
    opacity: 0;
    transform: translateY(50px) scale(0.8);
  }
  50% {
    opacity: 0.8;
    transform: translateY(-10px) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Animation Classes */
.animate-ready {
  opacity: 0;
}

.animate-fadeInUp {
  animation: fadeInUp 0.8s ease-out forwards;
}

.animate-fadeInLeft {
  animation: fadeInLeft 0.8s ease-out forwards;
}

.animate-fadeInRight {
  animation: fadeInRight 0.8s ease-out forwards;
}

.animate-bounceInUp {
  animation: bounceInUp 1s ease-out forwards;
}

/* Força o hover do botão WhatsApp */
.whatsapp-section .whatsapp-content .whatsapp-button {
  transition: transform 1s ease, background 1s ease, box-shadow 1s ease !important;
}

.whatsapp-section .whatsapp-content .whatsapp-button:hover {
  background: #7bb100 !important;
  transform: scale(1.05) !important;
  box-shadow: 0 6px 20px rgba(37, 69, 211, 0.4) !important;
  text-decoration: none !important;
  color: white !important;
}

/* Regra adicional para garantir funcionamento */
a.whatsapp-button {
  transition: transform 1s ease, background 1s ease, box-shadow 1s ease !important;
}

a.whatsapp-button:hover {
  background: #1a3a7a !important;
  transform: scale(1.05) !important;
  box-shadow: 0 6px 20px rgba(37, 69, 211, 0.4) !important;
  text-decoration: none !important;
  color: white !important;
}


/* Regra adicional para imagens dos logos */
img.client-logo {
  transition: transform 1s ease !important;
}
 

/* WhatsApp Floating Button */
.whatsapp-floating-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  z-index: 1000;
  transition: all 0.3s ease;
  text-decoration: none;
  animation: pulse 2s infinite;
}

.whatsapp-floating-button:hover {
  background: #20BA5A;
  transform: scale(1.1);
  box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6);
  text-decoration: none;
}

.whatsapp-floating-icon {
  font-size: 30px !important;
  color: white !important;
}

/* Pulse Animation */
@keyframes pulse {
  0% {
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  }
  50% {
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.8), 0 0 0 10px rgba(37, 211, 102, 0.1);
  }
  100% {
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  }
}
</style>
